<template>
  <div>
    <Navbar activeDirectory="dati" activePage="geo-data"></Navbar>
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="card-body">
              Scarica il file GeoJSON dei lavori in corso<br><br>
              <button class="btn btn-primary" @click="download('lavori_in_corso')">Lavori in corso <i class="fa fa-download"></i><br><span class="badge badge-secondary">EPSG: 4326</span></button>
            </div>
          </div>          
        </div>
        <div class="col">
          <div class="card">
            <div class="card-body">
              Scarica il file GeoJSON delle segnalazioni emergenza e rifiuti<br><br>
              <button class="btn btn-primary" @click="download('segnalazioni')">Segnalazioni <i class="fa fa-download"></i><br><span class="badge badge-secondary">EPSG: 4326</span></button>
            </div>
          </div>          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Navbar } from "@/components";

export default {
  components: {
    Navbar
  },

  methods: {
    download(pg) {
      this.axios.get(`geojson/${pg}`).then(response=>{
        var reply = response.data;
        const url = window.URL.createObjectURL(new Blob([JSON.stringify(reply)]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${pg}.geojson`);
        document.body.appendChild(link);
        link.click();
      })
    }
  }

}
</script>

<style>

</style>